<clr-vertical-nav
    [clrVerticalNavCollapsible]="true"
    [(clrVerticalNavCollapsed)]="collapsed"
    class="vertical-nav sel-vertical-nav"
>
    <div
        *ngFor="let state of states; trackBy: trackByState"
        class="sel-nav-group-content"
    >
        <ng-container *ngIf="state.children">
            <ng-container *permissionCheck="state.name | stateNameToPermission">
                <vertical-nav-group
                    class="sel-secondary-nav-{{ state.label }}"
                    [collapsed]="collapsed"
                    [state]="state"
                ></vertical-nav-group>
            </ng-container>
        </ng-container>

        <ng-container *ngIf="!state.children">
            <button
                class="sel-link-text vertical-nav__nav-button"
                uiSrefActive="active"
                [uiSref]="state.name"
                clrVerticalNavLink
                *permissionCheck="state.name | stateNameToPermission"
            >
                <clr-icon
                    *ngIf="state.icon"
                    class="sel-clr-icon"
                    shape="{{ state.icon }}"
                    clrVerticalNavIcon
                ></clr-icon>
                {{ state.label }}
            </button>
        </ng-container>
    </div>
</clr-vertical-nav>
